import { render, staticRenderFns } from "./create-vendor.vue?vue&type=template&id=18ddcd20&scoped=true"
import script from "./create-vendor.vue?vue&type=script&lang=js"
export * from "./create-vendor.vue?vue&type=script&lang=js"
import style0 from "./create-vendor.vue?vue&type=style&index=0&id=18ddcd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ddcd20",
  null
  
)

export default component.exports